import theme from "@/theme";

export const stylesArticleInfoPanel = {
  container: {
    width: "809px",
    boxSizing: "border-box",
    display: "flex",
    alignItems: "center",
    padding: "16px",
    backgroundColor: "rgba(255, 255, 255, 0.9)",
    border: `1px solid ${theme.palette.custom.blueGray200}`,
    borderRadius: "22px",
    boxShadow: "0px 0px 14px 0px rgba(0, 0, 0, 0.05)",
  },

  content: {
    flex: "1 0 0",
    minWidth: 0,
    display: "flex",
    flexDirection: "column",
    gap: "16px",
    alignItems: "flex-start",
  },

  title: {
    fontFamily: "Inter",
    fontWeight: 500,
    fontSize: "18px",
    lineHeight: "155%",
    color: theme.palette.custom.blueGray900,
  },

  hideButton: {
    position: "relative",
    fontFamily: "Inter",
    fontWeight: 600,
    fontSize: "18px",
    lineHeight: "155%",
    color: theme.palette.custom.mainBlue,
    textTransform: "none",
    padding: 0,
    minWidth: 0,
    textDecoration: "none",

    "&::after": {
      content: '""',
      position: "absolute",
      left: 0,
      bottom: 3,
      width: "100%",
      height: "1px",
      backgroundColor: theme.palette.custom.mainBlue,
    },
  },

  list: {
    width: "100%",
    display: "flex",
    flexDirection: "column",
    gap: "6px",
    alignItems: "flex-start",
  },

  checkWrapper: {
    width: "20px",
    height: "20px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    marginRight: "1px",
    flexShrink: 0,
  },

  requirementText: (done: boolean) => ({
    fontFamily: "Inter",
    fontWeight: 500,
    fontSize: "14px",
    lineHeight: "145%",
    color: done ? theme.palette.custom.secondaryGreenLight : theme.palette.custom.blueGray600,
  }),

  accent: {
    fontWeight: 500,
    fontSize: "14px",
    lineHeight: "145%",
    color: theme.palette.custom.mainBlue,
  },
};
